import { useState, useEffect, useCallback } from "react";
import { apiClientPublic } from "src/api/apiService";
import { GetTariffsParams, TariffsResponse } from "../types";

interface UseTariffsResult {
  data: TariffsResponse | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useTariffs = (
  params: GetTariffsParams | null
): UseTariffsResult => {
  const [data, setData] = useState<TariffsResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    if (!params || !params.accountType || !params.lnspIds?.length) {
      setData(null);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await apiClientPublic.get<TariffsResponse>(
        `/eic/tariffs`,
        {
          params: {
            accountType: params.accountType,
            lnsp_ids: params.lnspIds.join(","),
          },
        }
      );

      setData(result.data);
    } catch (err) {
      setError(err as string);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [params?.accountType, params?.lnspIds]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refetch: fetchData,
  };
};
